import { render, staticRenderFns } from "./MarketBuyProduct.vue?vue&type=template&id=04e4f252&scoped=true&"
import script from "./MarketBuyProduct.vue?vue&type=script&lang=js&"
export * from "./MarketBuyProduct.vue?vue&type=script&lang=js&"
import style0 from "./MarketBuyProduct.vue?vue&type=style&index=0&id=04e4f252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e4f252",
  null
  
)

export default component.exports